import styled from 'styled-components';
import colors from 'styles/colors';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  
  position: absolute;
    top: 15px;
    right: 25px;

  path {
    transition: stroke 0.1s cubic-bezier(0, 0, 0, 0);
  }

  svg {
    padding-bottom: 0px;
  }

  &:hover {
    path {
      stroke: ${colors.primary.ocean};
    }
  }
`;